import { IProps } from './index'

const Nonin7500 = ({ onCancel }: IProps) => {
  return (
    <div
      className="reader-view"
      data-reader-view="device-instructions"
      data-device-type="n7500"
    >
      <h3 className="mb-6">
        <i className="fa fa-info-circle"></i>
        Instructions for resetting the oximeter
      </h3>
      <p>Please see the device owner/operator manual for instructions.</p>
      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
      </div>
    </div>
  )
}

export default Nonin7500
